import React from "react";

import cx from "classnames";

import SocialProofDetails from "@components/SocialProofDetails";
import {SocialProofDetailsViewType} from "@components/SocialProofDetails/interfaces";

import styles from "./MenuItemRibbon.scss";
import {MenuItemRibbonProps, RibbonType} from "./interfaces";

export default function MenuItemRibbon({
  itemId,
  almostGone,
  className,
  isDishDetails,
}: MenuItemRibbonProps): JSX.Element | null {
  // Render "Almost Gone!" ribbon if the `almostGone` prop is true
  if (almostGone) {
    return (
      <div className={cx(styles.socialProof, styles.dishDetailsWrapper)}>
        <span className={styles.socialProofDescription}>
          {RibbonType.AlmostGone}
        </span>
      </div>
    );
  }
  // Render SocialProofDetails ribbon for other cases
  return (
    <SocialProofDetails
      itemId={itemId}
      detailsType={SocialProofDetailsViewType.Ribbon}
      className={className}
      isDishDetails={isDishDetails}
    />
  );
}
